import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';
import { isNullOrUndefined } from 'util';

import { Cxcencndcli } from "../cxcinterfaces/cxcencndcli";
import { Cxcdetndcli } from "../cxcinterfaces/cxcdetndcli";

@Injectable({
  providedIn: 'root'
})
export class CxcimportarndService {

  public way: string;

  public encndcli: Cxcencndcli[] = [];
  //public detregcomp: Cxcdetregcomp[][] = [];
  public _detndcli: Cxcdetndcli[];
  get detndcli(): Cxcdetndcli[] {
    return this._detndcli;
  }

  set detndcli(value: Cxcdetndcli[]) {
    this._detndcli = value;
  }

  constructor(
    private http: HttpClient,
    public usuarioEsquema: UsuarioEsquema,
    private confIniciales: ConfInicialesService,
    private usuario: Usuario
  ) {
    this.way = sessionStorage.getItem('way');
  }

  insertartmpdepcli(registros) {

    return this.http.post<any[]>(this.way + '/cxc/cxcimpnd/4afc76faaedb3400000', {
      elementos: {
        arreglo: registros,

        usuario: this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getclivalidacion(): Promise<any> {
    return this.http.post<any[]>(this.way + '/cxc/cxcimpnd/10777eaac9aa6500000000', {
      elementos: {
        p_USUIDENTIFICACION: this.usuario.identificacion
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getvenvalidacion(): Promise<any> {
    return this.http.post<any[]>(this.way + '/cxc/cxcimpnd/10777eaac9aafc00000000', {
      elementos: {
        p_USUIDENTIFICACION: this.usuario.identificacion
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getconvalidacion(): Promise<any> {
    return this.http.post<any[]>(this.way + '/cxc/cxcimpnd/10777eaac9aa6600000000', {
      elementos: {
        p_USUIDENTIFICACION: this.usuario.identificacion
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getconbanvalidacion(): Promise<any> {
    return this.http.post<any[]>(this.way + '/cxc/cxcimpnd/83bbf5564d533000000000000', {
      elementos: {
        p_USUIDENTIFICACION: this.usuario.identificacion
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertaencndimpcli(item) {
    return this.http.post<any[]>(this.way + '/cxc/cxcimpnd/257e3b7d53aecc000000000', {
      elementos: {
        p_ENCNDCLI_NUMERO: item.ENCNDCLI_NUMERO,
        p_COM_CODIGO: '01',
        p_ENCNDCLI_FECHA: item.ENCNDCLI_FECHA,
        p_ENCNDCLI_CONCEPTO: item.ENCNDCLI_CONCEPTO,
        p_ENCNDCLI_ESTADO: item.ENCNDCLI_ESTADO,
        p_USUIDENTIFICACION: this.usuario.identificacion,


      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  actualizaencndimpcli(item) {
    return this.http.post<any[]>(this.way + '/cxc/cxcimpnd/14cebaecbb656d0000', {
      elementos: {
        p_ENCNDCLI_NUMERO: item.ENCNDCLI_NUMERO,
        p_COM_CODIGO: '01',
        p_ENCNDCLI_FECHA: item.ENCNDCLI_FECHA,
        p_ENCNDCLI_CONCEPTO: item.ENCNDCLI_CONCEPTO,
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertarregistrodet(areglodet) {
    return this.http.post<any[]>(this.way + '/cxc/cxcimpnd/257e3b7d535ddc000000000', {
      elementos: {
        areglodet
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getencndimpcli(numero) {
    return this.http.post<any[]>(this.way + '/cxc/cxcimpnd/20eebaecbb656c0000', {
      elementos: {
        p_ENCNDCLI_NUMERO: numero,
        p_COM_CODIGO: '01'

      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getdetndimpcli(numero) {
    return this.http.post<any[]>(this.way + '/cxc/cxcimpnd/20eeb5ddbb656c0000', {
      elementos: {
        p_ENCNDCLI_NUMERO: numero,
        p_COM_CODIGO: '01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  seleccionarRegistro(tipo, numero): Observable<any> {
    return this.http.post<any>(this.way + '/cxc/cxcimpnd/39573192c5d5be0000000000000000000', {
      elementos: {
        p_tipo: tipo,
        p_com_codigo: '01',
        p_ENCDEPCLI_NUMERO: numero
      }
    }, this.confIniciales.httpOptions());
  }
  countregci(numero) {
    return this.http.post<any[]>(this.way + '/cxc/cxcimpnd/198f5fbb743bbc00000000000000', {
      elementos: {
        p_ENCNDCLI_NUMERO: numero,
        p_COM_CODIGO: '01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  borrarRegistro(numero) {
    return this.http.post<any[]>(this.way + '/cxc/cxcimpnd/3ab2b4aeadbaec0000000000', {
      elementos: {
        p_ENCNDCLI_NUMERO: numero,
        p_COM_CODIGO: '01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  generarnotasdebito(numero) {
    return this.http.post<any[]>(this.way + '/cxc/cxcimpnd/20ebbb6addf1d6000000000', {
      elementos: {
        p_ENCNDCLI_NUMERO: numero,
        p_COM_CODIGO: '01',
        p_usu_identificacion: this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  reversarnotasdebito(numero) {
    return this.http.post<any[]>(this.way + '/cxc/cxcimpnd/6ddf76f8addf1c0000000000', {
      elementos: {
        p_ENCNDCLI_NUMERO: numero,
        p_COM_CODIGO: '01',
        p_usu_identificacion: this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminadetregistro(item) {
    return this.http.post<any[]>(this.way + '/cxc/cxcimpnd/3ab2b4aea6bbb800000', {
      elementos: {
        p_ENCNDCLI_NUMERO: item.ENCNDCLI_NUMERO,
        p_COM_CODIGO: '01',
        p_DETNDCLI_LINEA: item.DETNDCLI_LINEA
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
}
